// extracted by mini-css-extract-plugin
export default {"stock-transfer-report-container":"StockTransferReport_stock-transfer-report-container__wjwEO"};